import { create } from "zustand";
import { TabsState } from "../types";

/**
 * Tabs store for managing tab state
 * This store is not persisted as it's temporary state
 */
const useTabsStore = create<TabsState>()((set) => ({
  tab: "questions",
  setTab: (tab) => set({ tab }),
}));

export default useTabsStore;
